import React from 'react';
import { FullPageLoader } from 'shared/components/loading';
import { useGetMenuCustomization } from '../data-access';
import { FontsForm } from './fonts-form';

export function Fonts(): JSX.Element | null {
  const { data, loading } = useGetMenuCustomization();

  if (loading) {
    return <FullPageLoader />;
  }

  if (data) {
    return <FontsForm data={data} />;
  }

  console.error(new Error(`missing web customization data`));
  return null;
}
